import React from 'react';
import styled from 'styled-components';

import Button from '#/components/basic/Button/Button';
import { KATANA_PERPS } from '#/config/constants';

import BankrollCustomRates from './BankrollCustomRates';
import BankrollModalLayout from './BankrollModalLayout';

const Heading = styled.div`
  color: var(--white);
  padding-top: 4px;
  padding-bottom: 24px;
`;

const RatesWrap = styled.div`
  padding-bottom: 24px;
`;

export default function BankrollCustomRatesAppliedModal({
  referralRateOverride,
  referredDiscountRateOverride,
  message,
  onClose,
}: {
  referralRateOverride: string | null | undefined;
  referredDiscountRateOverride: string | null | undefined;
  message: string | undefined;
  onClose: () => void;
}) {
  return (
    <BankrollModalLayout quantity={undefined} onClose={onClose}>
      <Heading>{message || <>Welcome to {KATANA_PERPS}!</>}</Heading>
      <RatesWrap>
        <BankrollCustomRates
          referralRateOverride={referralRateOverride}
          referredDiscountRateOverride={referredDiscountRateOverride}
          walletConnected
          onClose={onClose}
        />
      </RatesWrap>
      <div>
        <Button onClick={onClose} bordered inline widePadding>
          Start Trading
        </Button>
      </div>
    </BankrollModalLayout>
  );
}
